module.exports = __webpack_public_path__ + "img/fctimg01@2x (1)_wps.216eff91.png";